import {MetaTags} from 'components/seo';
import {AuthLayout} from 'components/users/auth_layout';
import {DreamCTA} from 'components/users/cta';
import {LogIn} from 'components/users/login';
import {useRouter} from 'next/router';
import {IQPage} from 'types/page';
import {withUser} from 'users';

const LogInPage: IQPage = () => {
  const router = useRouter();

  return (
    <main>
      <MetaTags title='Log In' />
      <AuthLayout cta={<DreamCTA />}>
        <LogIn onSuccess={(user) => router.push((router.query.next as string) || user.startURL)} />
      </AuthLayout>
    </main>
  );
};

export default LogInPage;

LogInPage.layoutConfig = {
  hideHeader: true,
  hideAuthBanner: true,
  fullWidth: true,
  hideSaleBanner: true,
  hideMockInterviewsBanner: true,
};

export const getServerSideProps = withUser({publicRequired: true});
